import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Icon } from "semantic-ui-react";

import { CustomerExternalDataModal, CustomerSearch } from "modules/Appointments/components/NewAppointment/components/CustomerSearchFormSection/components";
import { useListCustomersQuery } from "modules/CustomersDashboard/hooks";

import type { CUSTOMER_TYPES, Customer } from "models";
import type { HandleCustomerResultSelectParams, SEARCH_TAGS } from "modules/Appointments/components/NewAppointment";
import type { SetStateAction } from "react";

type CustomerSearchFormSectionProps = {
  showCarTag: SEARCH_TAGS | null;
  isDisabledOwnerSearch: boolean;
  isDisabledDriverSearch: boolean;
  isDisabledContractorSearch: boolean;
  activeCustomerTab: CUSTOMER_TYPES;
  customerSearchTerm: string;
  showCustomerType: string | null;
  selectedCustomer: Customer | null | undefined;
  handleSetCustomerSearchTerm: (value: SetStateAction<string>) => void;
  handleSetShowCustomerType: (value: SetStateAction<string | null>) => void;
  handleSetSelectedCustomer: (value: SetStateAction<Customer | null | undefined>) => void;
  handleCustomerTabChange: (value: CUSTOMER_TYPES) => void;
  handleCustomerResultSelect: ({ customer, customerType }: HandleCustomerResultSelectParams) => void;
};

export const CustomerSearchFormSection = ({
  showCarTag,
  activeCustomerTab,
  isDisabledOwnerSearch,
  isDisabledDriverSearch,
  isDisabledContractorSearch,
  customerSearchTerm,
  showCustomerType,
  selectedCustomer,
  handleSetCustomerSearchTerm,
  handleSetShowCustomerType,
  handleSetSelectedCustomer,
  handleCustomerTabChange,
  handleCustomerResultSelect
}: CustomerSearchFormSectionProps) => {
  const { t } = useTranslation();

  const [showCustomerExternalDataModal, setShowCustomerExternalDataModal] = useState(false);

  const {
    listCustomersData,
    refetchListCustomers: refetchCustomersByName,
    isFetchingCustomersList: isCustomerSearchByNameLoading
  } = useListCustomersQuery(customerSearchTerm);

  const customersByName = listCustomersData?.items;

  return (
    <>
      <Form.Group className="mt-25 NewAppointment__GrayGroup NewAppointment__no-margin">
        <Form.Field className="dropdown-search" width={6}>
          <label className="big">
            <Icon className="user" />
            {t("v8_customer", "Customer")}
          </label>
          <div className="search car">
            <CustomerSearch
              customersByName={customersByName}
              customerSearchTerm={customerSearchTerm}
              showCustomerType={showCustomerType}
              activeCustomerTab={activeCustomerTab}
              isDisabledOwnerSearch={isDisabledOwnerSearch}
              isDisabledDriverSearch={isDisabledDriverSearch}
              isDisabledContractorSearch={isDisabledContractorSearch}
              isCustomerSearchByNameLoading={isCustomerSearchByNameLoading}
              setSelectedCustomer={handleSetSelectedCustomer}
              setShowCustomerType={handleSetShowCustomerType}
              setCustomerSearchTerm={handleSetCustomerSearchTerm}
              refetchCustomersByName={refetchCustomersByName}
              handleCustomerTabChange={handleCustomerTabChange}
              handleCustomerResultSelect={handleCustomerResultSelect}
            />
            <Button
              type="button"
              className="-appointment-status left-icon mt-14 rowButton"
              disabled={!showCarTag || !selectedCustomer}
              onClick={() => setShowCustomerExternalDataModal(true)}
            >
              {t("v8_external_data", "External Data")}
            </Button>
          </div>
        </Form.Field>
      </Form.Group>

      <CustomerExternalDataModal
        customer={selectedCustomer}
        open={showCustomerExternalDataModal}
        activeCustomerTab={activeCustomerTab}
        onClose={() => setShowCustomerExternalDataModal(false)}
      />
    </>
  );
};
